import { FunctionalComponent, h } from '@stencil/core';
import { isPageVisible } from '../dot-navigation.utils';
import { FAR_DOT, FARTHER_DOT } from '../dot-navigation.constants';

interface DotElementProps {
  key: number;
  transitionPage: number;
}

export const DotElement: FunctionalComponent<DotElementProps> = ({ key, transitionPage }) => {
  const isDotVisible = isPageVisible(key, transitionPage);
  const isDotActive = key === transitionPage;
  const isDotFar = key === transitionPage - FAR_DOT || key === transitionPage + FAR_DOT;
  const isDotFarther = key === transitionPage - FARTHER_DOT || key === transitionPage + FARTHER_DOT;

  return (
    <button //
      tabindex="-1"
      type="button"
      class={{ dot: true, visible: isDotVisible, active: isDotActive, far: isDotFar, farther: isDotFarther }}
    />
  );
};
